class GiftCardBalance extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector(`.gc-balance-lookup__form`);
    this.input = this.querySelector(`.gc-balance-lookup__input`);
    this.result = this.querySelector(`.gc-balance-lookup__result`);
    this.submitBtn = this.querySelector(`.gc-balance-lookup__submit`);
    this.defaultButtonText = this.submitBtn.textContent;

    this.form.addEventListener(`submit`, this.onSubmit.bind(this));
  }

  onSubmit(event) {
    event.preventDefault();

    const code = this.input.value.trim();

    this.result.hidden = true;
    this.result.className = `gc-balance-lookup__result`;
    this.result.innerHTML = ``;

    if (!code) {
      this.showError(`Please enter your gift card code.`);
      return;
    }

    this.submitBtn.disabled = true;
    this.submitBtn.textContent = `Checking…`;

    const url = `${this.dataset.apiBase}?code=${encodeURIComponent(code)}&shop=${encodeURIComponent(this.dataset.shop)}`;

    fetch(url)
      .then((response) => {
        return response.json().then((data) => {
          return { ok: response.ok, data };
        });
      })
      .then((response) => {
        if (!response.ok) {
          this.showError(response.data.error || `Gift card not found.`);
        } else {
          this.showBalance(response.data);
        }
      })
      .catch(() => {
        this.showError(`Something went wrong. Please try again.`);
      })
      .finally(() => {
        this.submitBtn.disabled = false;
        this.submitBtn.textContent = this.defaultButtonText;
      });
  }

  showError(message) {
    this.result.className = `gc-balance-lookup__result gc-balance-lookup__result--error`;
    this.result.innerHTML = message;
    this.result.hidden = false;
  }

  showBalance(data) {
    const expires = this.formatDate(data.expiresOn);
    const expiresHtml = expires ? `<span class="gc-expires">Expires ${expires}</span>` : ``;

    this.result.className = `gc-balance-lookup__result gc-balance-lookup__result--success`;
    this.result.innerHTML = `
      Current Balance
      <span class="gc-amount">${this.formatCurrency(data.balance, data.currencyCode)}</span>
      ${expiresHtml}
    `;
    this.result.hidden = false;
  }

  formatCurrency(amount, currencyCode) {
    return new Intl.NumberFormat(`en-US`, { style: `currency`, currency: currencyCode }).format(amount);
  }

  formatDate(dateString) {
    if (!dateString) {
      return null;
    }

    return new Date(dateString).toLocaleDateString(`en-US`, {
      year: `numeric`,
      month: `long`,
      day: `numeric`,
    });
  }
}

customElements.define(`gift-card-balance`, GiftCardBalance);
